import styled from "styled-components"

export const StyledScannedPhoto = styled.div`
  position: relative;
  overflow: hidden;
  height: 327px;
  border-radius: 12px;

  @keyframes scan-to-bottom {
    0% {
      transform: translatey(-100px);
    }

    65% {
      transform: translatey(500px);
    }

    65.01%,
    100% {
      transform: translatey(500px);
    } 
  }

  @keyframes scan-to-top {
    0%,
    35% {
      transform: translatey(500px);
    }

    35.01% {
      transform: translatey(500px);
    }

    100% {
      transform: translatey(-100px);
    }
  }

  .scan-to-bottom {
    width: 100%;
    height: 100px;
    border-bottom: 2px solid var(--Schemes-Primary-Container, #4bd9de);
    background: linear-gradient(
      179deg,
      rgba(255, 255, 255, 0) 0.64%,
      rgba(13, 163, 186, 0.54) 99.4%
    );

    animation: scan-to-bottom 3s linear infinite;
    position: absolute;
    top: 0;
  }

  .scan-to-top {
    width: 100%;
    height: 100px;
    border-top: 2px solid var(--Schemes-Primary-Container, #4bd9de);
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 0) 0.64%,
      rgba(13, 163, 186, 0.54) 99.4%
    );
    animation: scan-to-top 3s linear infinite;
    position: absolute;
    top: 0;
  }
`

export const ReviewPhoto = styled.img`
  width: 100%;
  height: 327px;
  object-fit: cover;
  border-radius: 12px;
`

export const Wrapper = styled.div`
  padding: 24px;
  background: #fff;
`
